<template>
  <div>
    <ShowSignInCustom
      v-if="displayMap.showSignIn"
      v-bind:signUpConfig="options.signUpConfig"
      v-bind:usernameAttributes="options.usernameAttributes"
      v-bind:confirmSignUpConfig="options.confirmSignUpConfig"
    />
    <amplify-sign-up
      v-if="displayMap.showSignUp"
      v-bind:signUpConfig="options.signUpConfig"
      v-bind:usernameAttributes="options.usernameAttributes"
    />
    <amplify-confirm-sign-up
      v-if="displayMap.showConfirmSignUp"
      v-bind:confirmSignUpConfig="options.confirmSignUpConfig"
      v-bind:usernameAttributes="options.usernameAttributes"
    />
    <ConfirmSignInCustom
      v-if="displayMap.showConfirmSignIn"
      v-bind:confirmSignInConfig="options.confirmSignInConfig"
    />
    <ForgotPasswordCustom
      v-if="displayMap.showForgotPassword"
      v-bind:forgotPasswordConfig="options.forgotPasswordConfig"
      v-bind:usernameAttributes="options.usernameAttributes"
      v-bind:passwordResetByConsole="options.passwordResetByConsole"
    />
    <amplify-require-new-password
      v-if="displayMap.requireNewPassword"
      v-bind:requireNewPasswordConfig="options.requireNewPasswordConfig"
    />
    <amplify-set-mfa
      v-if="displayMap.showMfa"
      v-bind:mfaConfig="options.mfaConfig"
    />
  </div>
</template>

<script>
import GetUser from 'aws-amplify-vue/src/services/getUser';
import { AmplifyEventBus } from 'aws-amplify-vue';
import ConfirmSignInCustom from '@/components/authentication/ConfirmSignInCustom.vue';
import ForgotPasswordCustom from '@/components/authentication/ForgotPasswordCustom.vue';
import ShowSignInCustom from '@/components/authentication/ShowSignInCustom.vue';

export default {
  name: 'AuthenticatorCustom',
  props: ['authConfig'],
  components: {
    ConfirmSignInCustom,
    ForgotPasswordCustom,
    ShowSignInCustom,
  },
  data() {
    return {
      user: {
        username: null,
      },
      displayMap: {},
      error: '',
      logger: {},
    };
  },
  computed: {
    options() {
      const defaults = {
        signInConfig: {},
        signUpConfig: {},
        confirmSignUpConfig: {},
        confirmSignInConfig: {},
        forgotPasswordConfig: {},
        passwordResetByConsole: false,
        mfaConfig: {},
        requireNewPasswordConfig: {},
        usernameAttributes: 'username',
      };
      return Object.assign(defaults, this.authConfig || {});
    },
  },
  async mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
    AmplifyEventBus.$on('localUser', (user) => {
      this.user = user;
      this.options.signInConfig.username = this.user.username;
      this.options.confirmSignInConfig.user = this.user;
      this.options.confirmSignUpConfig.username = this.user.username;
      this.options.requireNewPasswordConfig.user = this.user;
    });
    AmplifyEventBus.$on('authState', (data) => {
      if (data === 'passwordResetByConsole') {
        this.options.passwordResetByConsole = true;
      }
      this.displayMap = this.updateDisplayMap(data);
    });
    GetUser(this.$Amplify)
      .then((val) => {
        if (val instanceof Error) {
          // eslint-disable-next-line no-return-assign
          return (this.displayMap = this.updateDisplayMap('signedOut'));
        }
        this.user = val;
        // eslint-disable-next-line no-return-assign
        return (this.displayMap = this.updateDisplayMap('signedIn'));
      })
      .catch((e) => this.setError(e));
  },
  methods: {
    updateDisplayMap: (state) => ({
      showSignIn: state === 'signedOut' || state === 'signIn',
      showSignUp: state === 'signUp',
      showConfirmSignUp: state === 'confirmSignUp',
      showConfirmSignIn: state === 'confirmSignIn',
      showForgotPassword:
        state === 'forgotPassword' || state === 'passwordResetByConsole',
      showSignOut: state === 'signedIn',
      showMfa: state === 'setMfa',
      requireNewPassword: state === 'requireNewPassword',
    }),
    setError(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    },
  },
};
</script>
